import { SandCoatingFormulationsPayload } from 'generated/graphql';
// constant, interfaces
import { PAGE_LIMIT, selectTypeInitialValues, TabEnum } from 'constants/index';
import { SelectType } from 'interfaces';

export type State = {
  page: number;
  count: number;
  search: string;
  rowsPerPage: number;
  activeTab: TabEnum;
  sandCoating: SelectType;
  productSize: SelectType;
  productType: SelectType;
  subProductType: SelectType;
  data: SandCoatingFormulationsPayload['data'];
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  search: '',
  rowsPerPage: PAGE_LIMIT,
  activeTab: TabEnum.Active,
  sandCoating: selectTypeInitialValues,
  productSize: selectTypeInitialValues,
  productType: selectTypeInitialValues,
  subProductType: selectTypeInitialValues,
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
  SET_SAND_COATING = 'setSandCoating',
  SET_PRODUCT_SIZE = 'setProductSize',
  SET_PRODUCT_TYPE = 'setProductType',
  SET_SUB_PRODUCT_TYPE = 'setSubProductType',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: number }
  | { type: ActionType.SET_COUNT; count: number }
  | { type: ActionType.SET_SEARCH; search: string }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: TabEnum }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: number }
  | { type: ActionType.SET_DATA; data: SandCoatingFormulationsPayload['data'] }
  | { type: ActionType.SET_SAND_COATING; sandCoating: SelectType }
  | { type: ActionType.SET_PRODUCT_SIZE; productSize: SelectType }
  | { type: ActionType.SET_PRODUCT_TYPE; productType: SelectType }
  | { type: ActionType.SET_SUB_PRODUCT_TYPE; subProductType: SelectType };

export const sandCoatingFormulationReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_SAND_COATING:
      return {
        ...state,
        sandCoating: action.sandCoating,
      };

    case ActionType.SET_PRODUCT_SIZE:
      return {
        ...state,
        productSize: action.productSize,
      };

    case ActionType.SET_PRODUCT_TYPE:
      return {
        ...state,
        productType: action.productType,
      };

    case ActionType.SET_SUB_PRODUCT_TYPE:
      return {
        ...state,
        subProductType: action.subProductType,
      };
  }
};
